import React from 'react';

const Email = () => (<div>
  <div className="box-100 p-5 border-grey">
    <h3>Support</h3>
    <p className="answer">Get in touch with us about anything. Ideas, suggestions or complaints.</p>
    <h5 style={{marginTop: '20px'}} onClick={() => window.$crisp.push(['do', 'chat:open'])}>
      <a className="link">Chat with us</a>
    </h5>
    <p className="text-sm">Or send an email to <a href="mailto:support@tiiny.host">support@tiiny.host</a> - We reply within 12 hours. </p>
  </div>
</div>);

export default Email;
